export const getCookieMainDomain = () => `${getCookieDomainFromHost(window?.location.hostname || 'dundle.com')}`;

export function getCookieDomainFromHost(host) {
    const domainParts = host.split('.');
    const baseDomain = domainParts.slice(-2).join('.');
    const domainForCookie = baseDomain.includes('localhost') ? baseDomain.split(':')[0] : `.${baseDomain}`;
    return domainForCookie;
}
